import React, { useState, useEffect } from 'react';
import { Shield, ShoppingCart, Wrench, Plus, Trash2, Megaphone } from "lucide-react";
import axios from 'axios';
import LoadingOverlay from '../components/LoadingOverlay'; // Importa el overlay
import CatalogoWeb from '../components/CatalogoWeb';
import { GridComponent, ColumnsDirective, ColumnDirective, Page, Selection, Inject,Toolbar, Sort, Filter } from '@syncfusion/ej2-react-grids';
import { Tabs, Tab, Select, MenuItem, useMediaQuery } from '@mui/material';

const avatarDefault = '/avatars/avatar.jpg';

const Seguridad = () => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [selectedTab, setSelectedTab] = useState(0);
  const [profile, setProfile] = useState(null);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    telefono: ""
  });
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedModules, setSelectedModules] = useState([]);
  const allModules = [
    "Dashboard",
    "Cotizaciones",
    "Órdenes",
    "Agenda",
    "Instalación",
    "Stock",
    "Clientes",
    "Finanzas",
    "Seguridad",
    "Marketing",
  ];

  const PROTECTED_ROLES = ["Administrador", "Vendedor", "Instalador"];

  const roleIcon = (name) => {
    if (name === "Administrador") return <Shield className="w-8 h-8 text-yellow-600" />;
    if (name === "Vendedor") return <ShoppingCart className="w-8 h-8 text-blue-600" />;
    if (name === "Instalador") return <Wrench className="w-8 h-8 text-green-600" />;
    if (name === "Marketing") return <Megaphone className="w-8 h-8 text-[#FF743A]" />;
    return <Shield className="w-8 h-8 text-gray-400" />;
  };
  const [isCreatingUser, setIsCreatingUser] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [editFormData, setEditFormData] = useState({
  username: "",
  first_name: "",
  last_name: "",
  email: "",
  telefono: "",
  password: "",
  groups: [],
});
  const [openModal, setOpenModal] = useState(false);
  const [modalError, setModalError] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(false);

  const [openRoleModal, setOpenRoleModal] = useState(false);
  const [newRoleName, setNewRoleName] = useState("");
  const [roleModalError, setRoleModalError] = useState(null);
  const [confirmDeleteRole, setConfirmDeleteRole] = useState(null);

  const handleRowSelected = (args) => {
    if (!args || !args.data) return;
    const user = args.data; // datos de la fila
    setSelectedUser(user);
    setEditFormData({
    username: user.username || "",
    first_name: user.first_name || "",
    last_name: user.last_name || "",
    email: user.email || "",
    telefono: user.telefono || "",
    groups: user.groups && user.groups.length > 0 ? user.groups : [], // 👈 asegura array
  });
    setIsCreatingUser(false);
    setModalError(null);
    setOpenModal(true);
  };
  const handleDeleteUser = async () => {
    try {
      const token = localStorage.getItem("access_token");
      await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/${selectedUser.id}/`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/users/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUsers(response.data);
      setConfirmDelete(false);
      setOpenModal(false);
    } catch (err) {
      console.error(err);
      setConfirmDelete(false);
      setModalError("Error al eliminar el usuario.");
    }
  };

  const handleSaveUser = async () => {
    if (!editFormData.username || !editFormData.first_name || !editFormData.telefono || editFormData.groups.length === 0) {
      alert("Debes completar Usuario, Nombre, Teléfono y Rol ❌");
      return;
    }
    if (isCreatingUser && !editFormData.password) {
      alert("Debes ingresar una contraseña ❌");
      return;
    }
  try {
    const token = localStorage.getItem("access_token");

    if (isCreatingUser) {
      // POST → Crear usuario (incluye password)
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/`,
        editFormData,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert("Usuario creado correctamente ✅");
    } else {
      // PATCH → Editar usuario (excluye password)
      const { password, ...patchData } = editFormData;
      await axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/${selectedUser.id}/`,
        patchData,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert("Usuario actualizado correctamente ✅");
    }

    // refrescar lista
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/users/`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setUsers(response.data);

    setOpenModal(false);
    setIsCreatingUser(false);
  } catch (err) {
    console.error(err);
    const data = err.response?.data;
    if (data && typeof data === "object") {
      const messages = Object.entries(data)
        .map(([field, msgs]) => `${field}: ${Array.isArray(msgs) ? msgs.join(", ") : msgs}`)
        .join("\n");
      setModalError(messages);
    } else {
      setModalError("Error al guardar el usuario.");
    }
  }
};

  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem("access_token");
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/users/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUsers(response.data);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
    fetchUsers();
  }, []);

  // columnas para la grilla
  const usersGrid = [
    { field: "id", headerText: "ID", width: "60", textAlign: "Center", isPrimaryKey: true },
    { field: "username", headerText: "Usuario", width: "120" },
    { field: "first_name", headerText: "Nombre", width: "120" },
    { field: "last_name", headerText: "Apellido", width: "120" },
    { field: "email", headerText: "Email", width: "200" },
    { field: "telefono", headerText: "Teléfono", width: "150" },
    { 
      field: "groups", 
      headerText: "Rol", 
      width: "150", 
      template: (props) => props.groups.join(", ") || "—" 
    },
  ];

  // Nueva función reutilizable
  const fetchRoles = async () => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/users/roles/`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setRoles(response.data);

    // si ya había un rol seleccionado, actualiza con la nueva versión desde backend
    if (selectedRole) {
      const updated = response.data.find(r => r.id === selectedRole.id);
      if (updated) {
        setSelectedRole(updated);
        setSelectedModules(updated.modules); // ✅ sobrescribe siempre
      }
    }
  } catch (error) {
    console.error("Error fetching roles:", error);
  }
};

  useEffect(() => {
    fetchRoles();
  }, []);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleSave = async () => {
  try {
    const token = localStorage.getItem("access_token");
    await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}/api/users/${profile.id}/`,
      formData,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    // refrescar datos
    const refreshed = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/users/me/`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setProfile(refreshed.data);
    setFormData({
      first_name: refreshed.data.first_name || "",
      last_name: refreshed.data.last_name || "",
      email: refreshed.data.email || "",
      telefono: refreshed.data.telefono || "",
    });    
    alert("Perfil actualizado correctamente ✅");
  } catch (error) {
    console.error("Error al actualizar perfil:", error);
    alert("Error al actualizar perfil ❌");
  }
};
useEffect(() => {
  const fetchProfile = async () => {
    try {
      const token = localStorage.getItem('access_token'); 
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/users/me/`, {
              
              headers: { Authorization: `Bearer ${token}` },
            });
      setProfile(response.data);
      setFormData({
        
        first_name: response.data.first_name || "",
        last_name: response.data.last_name || "",
        email: response.data.email || "",
        telefono: response.data.telefono || ""
      });
      console.log("Fetched profile:", response.data);
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  fetchProfile();
}, []);

// El catálogo web (mapeo cotizador web → láminas de bodega) solo lo administra el rol Administrador
const esAdmin = profile?.groups?.includes('Administrador');

const getUserAvatar = (username) => {
  return `/avatars/${username}.jpg`;
};

const handleCreateRole = async () => {
  if (!newRoleName.trim()) {
    setRoleModalError("El nombre del rol no puede estar vacío.");
    return;
  }
  try {
    setLoading(true);
    setLoadingMessage("Creando rol...");
    const token = localStorage.getItem("access_token");
    await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/api/users/roles/`,
      { name: newRoleName.trim() },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    setOpenRoleModal(false);
    setNewRoleName("");
    setRoleModalError(null);
    await fetchRoles();
  } catch (err) {
    const msg = err.response?.data?.name?.[0] || "Error al crear el rol.";
    setRoleModalError(msg);
  } finally {
    setLoading(false);
    setLoadingMessage("");
  }
};

const handleDeleteRole = async (roleId) => {
  try {
    setLoading(true);
    setLoadingMessage("Eliminando rol...");
    const token = localStorage.getItem("access_token");
    await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/api/users/roles/${roleId}/`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    setConfirmDeleteRole(null);
    await fetchRoles();
  } catch (err) {
    alert("Error al eliminar el rol ❌");
  } finally {
    setLoading(false);
    setLoadingMessage("");
  }
};

  return (
    <div className="h-full flex flex-col p-2 md:p-4 overflow-hidden">
      <div className="flex-1 min-h-0 flex flex-col bg-white rounded-3xl p-2 md:p-3 overflow-hidden">
      {loading && <LoadingOverlay message={loadingMessage} />}


{confirmDelete && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60]">
    <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0">
          <span className="text-red-600 text-xl font-bold">!</span>
        </div>
        <h2 className="text-lg font-semibold text-gray-800">Eliminar usuario</h2>
      </div>
      <p className="text-gray-700 mb-2">
        Estás a punto de eliminar a <strong>{selectedUser?.username}</strong>. Esta acción es irreversible.
      </p>
      <div className="bg-amber-50 border border-amber-200 rounded-md p-3 mb-6 text-sm text-amber-800">
        Todas las cotizaciones creadas por este usuario quedarán sin vendedor asignado.
      </div>
      <div className="flex justify-end gap-2">
        <button
          onClick={() => setConfirmDelete(false)}
          className="px-4 py-2 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50"
        >
          Cancelar
        </button>
        <button
          onClick={handleDeleteUser}
          className="px-4 py-2 rounded-md bg-red-600 text-white hover:bg-red-700 font-medium"
        >
          Sí, eliminar
        </button>
      </div>
    </div>
  </div>
)}

{openModal && (
  <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
    <div className="bg-white p-6 rounded-2xl shadow-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-semibold text-gray-800">
          {isCreatingUser ? "Agregar Usuario" : "Editar Usuario"}
        </h2>
        <button onClick={() => setOpenModal(false)} className="text-gray-400 hover:text-gray-600 text-3xl leading-none">&times;</button>
      </div>

      {/* Contenedor flex */}
      <div className="flex flex-col md:flex-row gap-6 items-start">
        {/* Avatar a la izquierda SOLO si es edición */}
        {!isCreatingUser && (
          <div className="flex-shrink-0 w-40 h-40 flex items-center justify-center">
            <img
              src={getUserAvatar(editFormData.username)}
              onError={(e) => { e.target.src = avatarDefault; }}
              alt="avatar"
              className="rounded-full w-36 h-36 object-cover border"
            />
          </div>
        )}

        {/* Formulario a la derecha */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Usuario {isCreatingUser && <span className="text-red-500">*</span>}
            </label>
            <input
              type="text"
              value={editFormData.username}
              onChange={(e) => setEditFormData({ ...editFormData, username: e.target.value })}
              disabled={!isCreatingUser}
              required={isCreatingUser}
              className="mt-1 block w-full border border-gray-300 rounded-md p-2"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Nombre <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={editFormData.first_name}
              onChange={(e) => setEditFormData({ ...editFormData, first_name: e.target.value })}
              required
              className="mt-1 block w-full border border-gray-300 rounded-md p-2"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Apellido</label>
            <input
              type="text"
              value={editFormData.last_name}
              onChange={(e) => setEditFormData({ ...editFormData, last_name: e.target.value })}
              className="mt-1 block w-full border border-gray-300 rounded-md p-2"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Email</label>
            <input
              type="email"
              value={editFormData.email}
              onChange={(e) => setEditFormData({ ...editFormData, email: e.target.value })}
              className="mt-1 block w-full border border-gray-300 rounded-md p-2"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Teléfono <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={editFormData.telefono}
              onChange={(e) => setEditFormData({ ...editFormData, telefono: e.target.value })}
              required
              className="mt-1 block w-full border border-gray-300 rounded-md p-2"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Rol <span className="text-red-500">*</span>
            </label>
            <select
              value={editFormData.groups[0] || ""}
              onChange={(e) => setEditFormData({ ...editFormData, groups: [e.target.value] })}
              required
              className="mt-1 block w-full border border-gray-300 rounded-md p-2"
            >
              <option value="">-- Selecciona un rol --</option>
              {roles.map((rol) => (
                <option key={rol.id} value={rol.name}>{rol.name}</option>
              ))}
            </select>
          </div>

          {isCreatingUser && (
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Contraseña <span className="text-red-500">*</span>
              </label>
              <input
                type="password"
                value={editFormData.password}
                onChange={(e) => setEditFormData({ ...editFormData, password: e.target.value })}
                required
                className="mt-1 block w-full border border-gray-300 rounded-md p-2"
              />
            </div>
          )}
        </div>
      </div>

      {modalError && (
        <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-md text-sm text-red-700 whitespace-pre-line">
          {modalError}
        </div>
      )}

      {/* Botones */}
      <div className="mt-6 flex justify-between gap-2">
        {!isCreatingUser && (() => {
          const isProtected = selectedUser?.username === "manychat" || editFormData.groups.includes("Administrador");
          return (
            <button
              type="button"
              onClick={() => setConfirmDelete(true)}
              disabled={isProtected}
              title={isProtected ? "Este usuario no puede eliminarse" : ""}
              className={`px-4 py-2 rounded-md text-white ${isProtected ? "bg-red-200 cursor-not-allowed" : "bg-red-500 hover:bg-red-600"}`}
            >
              Eliminar Usuario
            </button>
          );
        })()}
        <div className="flex gap-2 ml-auto">
          <button
            onClick={() => setOpenModal(false)}
            className="px-4 py-2 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50"
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={handleSaveUser}
            className="bg-[#FF743A] text-white py-2 px-4 rounded-md"
          >
            {isCreatingUser ? "Crear Usuario" : "Guardar Cambios"}
          </button>
        </div>
      </div>
    </div>
  </div>
)}
      {/* Modal: Crear Rol */}
      {openRoleModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-2xl shadow-lg w-full max-w-md">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold text-gray-800">Crear Nuevo Rol</h2>
              <button onClick={() => { setOpenRoleModal(false); setNewRoleName(""); setRoleModalError(null); }} className="text-gray-400 hover:text-gray-600 text-3xl leading-none">&times;</button>
            </div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Nombre del Rol</label>
            <input
              type="text"
              value={newRoleName}
              onChange={(e) => setNewRoleName(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleCreateRole()}
              placeholder="Ej: Marketing"
              className="block w-full border border-gray-300 rounded-md p-2 mb-3"
              autoFocus
            />
            {roleModalError && (
              <p className="text-sm text-red-600 mb-3">{roleModalError}</p>
            )}
            <p className="text-xs text-gray-500 mb-4">
              Después de crearlo, podrás asignarle módulos desde "Definir Permisos".
            </p>
            <div className="flex justify-end gap-2">
              <button onClick={() => { setOpenRoleModal(false); setNewRoleName(""); setRoleModalError(null); }} className="px-4 py-2 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50">Cancelar</button>
              <button onClick={handleCreateRole} className="px-4 py-2 rounded-md bg-[#FF743A] text-white">Crear Rol</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Confirmar eliminación de rol */}
      {confirmDeleteRole && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60]">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0">
                <span className="text-red-600 text-xl font-bold">!</span>
              </div>
              <h2 className="text-lg font-semibold text-gray-800">Eliminar rol</h2>
            </div>
            <p className="text-gray-700 mb-4">
              Estás a punto de eliminar el rol <strong>{confirmDeleteRole.name}</strong>. Los usuarios con este rol quedarán sin grupo asignado.
            </p>
            <div className="flex justify-end gap-2">
              <button onClick={() => setConfirmDeleteRole(null)} className="px-4 py-2 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50">Cancelar</button>
              <button onClick={() => handleDeleteRole(confirmDeleteRole.id)} className="px-4 py-2 rounded-md bg-red-600 text-white hover:bg-red-700 font-medium">Sí, eliminar</button>
            </div>
          </div>
        </div>
      )}

      <div className="flex justify-between items-center mb-2 flex-wrap gap-2">
        <p className="text-xl md:text-3xl font-extrabold tracking-tight text-slate-900">Seguridad</p>
        {isMobile ? (
          <Select value={selectedTab} onChange={(e) => setSelectedTab(e.target.value)} size="small" sx={{ minWidth: 180 }}>
            <MenuItem value={0}>Editar perfil</MenuItem>
            <MenuItem value={1}>Definir Roles</MenuItem>
            <MenuItem value={2}>Definir Permisos</MenuItem>
            <MenuItem value={3}>Gestión de Usuarios</MenuItem>
            {esAdmin && <MenuItem value={4}>Catálogo web</MenuItem>}
          </Select>
        ) : (
          <Tabs value={selectedTab} onChange={handleTabChange}
            sx={{
              '.MuiTab-root': { '&:hover': { color: '#FF743A' }, '&.Mui-selected': { color: '#FF743A' } },
              '.MuiTabs-indicator': { backgroundColor: '#FF743A' },
            }}
          >
            <Tab label="Editar perfil" />
            <Tab label="Definir Roles" />
            <Tab label="Definir Permisos" />
            <Tab label="Gestión de Usuarios" />
            {esAdmin && <Tab label="Catálogo web" />}
          </Tabs>
        )}
      </div>

      <div className="flex-1 overflow-y-auto mt-2">
      {/* Pestaña Editar Perfil */}
      {selectedTab === 0 && (
        <div>
          <div className="flex flex-col md:flex-row gap-4 items-center mt-6">
            {/* Imagen de perfil */}
            <div className="flex-shrink-0 w-40 h-40 flex items-center justify-center">
            {profile && (
              <img
                src={getUserAvatar(profile.username)}
                onError={(e) => { e.target.src = avatarDefault; }}
                alt="profile"
                className="rounded-full w-36 h-36 object-cover"
              />
            )}
            </div>

            {profile && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
                <div className="mt-4">
                  <label className="block text-sm font-medium text-gray-700">Nombre</label>
                  <input
                    type="text"
                    value={formData.first_name}
                    onChange={(e) => setFormData({ ...formData, first_name: e.target.value })}
                    className="mt-1 block w-full border border-gray-300 rounded-md p-2"
                  />
                </div>
                <div className="mt-4">
                  <label className="block text-sm font-medium text-gray-700">Apellido</label>
                  <input
                    type="text"
                    value={formData.last_name}
                    onChange={(e) => setFormData({ ...formData, last_name: e.target.value })}
                    className="mt-1 block w-full border border-gray-300 rounded-md p-2"
                  />
                </div>
                <div className="mt-4">
                  <label className="block text-sm font-medium text-gray-700">Email</label>
                  <input
                    type="email"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    className="mt-1 block w-full border border-gray-300 rounded-md p-2"
                  />
                </div>

                <div className="mt-4">
                  <label className="block text-sm font-medium text-gray-700">Teléfono</label>
                  <input
                    type="text"
                    value={formData.telefono}
                    onChange={(e) => setFormData({ ...formData, telefono: e.target.value })}
                    className="mt-1 block w-full border border-gray-300 rounded-md p-2"
                  />
                </div>
                
                <div className="mt-4">
                  <label className="block text-sm font-medium text-gray-700">Usuario</label>
                  <input
                    type="text"
                    value={profile.username}
                    disabled
                    className="mt-1 block w-full border border-gray-300 rounded-md p-2 bg-gray-100"
                  />
                </div>
                <div className="mt-4">
                  
                  <label className="block text-sm font-medium text-gray-700">Rol</label>
                  <input
                    type="text"
                    value={profile.groups.join(", ")}
                    disabled
                    className="mt-1 block w-full border border-gray-300 rounded-md p-2 bg-gray-100"
                  />
                </div>

              </div>
            )}
 
          </div>

          <div className="mt-6 flex justify-end">
          <button
            type="button"
            onClick={handleSave}
            className="bg-[#FF743A] text-white py-2 px-4 rounded-md"
          >
            Guardar
          </button>
          </div>
        </div>
      )}

      {/* Pestaña Definir Roles */}
{selectedTab === 1 && (
  <div className="mt-6">
    <div className="flex items-center justify-between mb-6">
      <div>
        <h2 className="text-lg font-medium text-gray-700">Roles del Sistema</h2>
        <p className="text-gray-500 text-sm mt-1">
          Los roles protegidos (Administrador, Vendedor, Instalador) no se pueden eliminar. Asigna módulos en "Definir Permisos".
        </p>
      </div>
      <button
        type="button"
        onClick={() => { setOpenRoleModal(true); setRoleModalError(null); setNewRoleName(""); }}
        className="flex items-center gap-2 bg-[#FF743A] text-white py-2 px-4 rounded-md text-sm"
      >
        <Plus className="w-4 h-4" />
        Crear Rol
      </button>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {roles.map((rol) => {
        const isProtected = PROTECTED_ROLES.includes(rol.name);
        return (
          <div key={rol.id} className="border rounded-xl p-6 shadow-sm hover:shadow-md transition bg-white relative">
            {!isProtected && (
              <button
                type="button"
                onClick={() => setConfirmDeleteRole(rol)}
                title="Eliminar rol"
                className="absolute top-3 right-3 text-gray-300 hover:text-red-500 transition"
              >
                <Trash2 className="w-4 h-4" />
              </button>
            )}
            <div className="flex items-center gap-3 mb-3">
              {roleIcon(rol.name)}
              <h3 className="text-lg font-semibold text-gray-800">{rol.name}</h3>
            </div>
            {rol.modules && rol.modules.length > 0 ? (
              <div className="flex flex-wrap gap-1">
                {rol.modules.map((m) => (
                  <span key={m} className="text-xs bg-orange-50 text-[#FF743A] border border-orange-200 rounded-full px-2 py-0.5">{m}</span>
                ))}
              </div>
            ) : (
              <p className="text-gray-400 text-sm italic">Sin módulos asignados</p>
            )}
          </div>
        );
      })}
    </div>
  </div>
)}

{/* Pestaña Definir Permisos */}
{selectedTab === 2 && (
  <div className="mt-6">
    <h2 className="text-lg font-medium text-gray-700 mb-4">
      Asignar Permisos a Roles
    </h2>
    {/* Selector de roles */}
    <div className="mb-6">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Seleccionar Rol
      </label>
      <select
        className="mt-1 block w-full md:w-1/3 border border-gray-300 rounded-md p-2"
        value={selectedRole?.id || ""}
        onChange={(e) => {
          const role = roles.find(r => r.id === parseInt(e.target.value));
          setSelectedRole(role);
          setSelectedModules(role?.modules || []);
        }}
      >
        <option value="">-- Selecciona un Rol --</option>
        {roles.map((rol) => (
          <option key={rol.id} value={rol.id}>
            {rol.name}
          </option>
        ))}
      </select>
    </div>

    {/* Permisos */}
    {selectedRole?.name === "Administrador" ? (
      <div className="rounded-xl border border-yellow-200 bg-yellow-50 p-5 flex items-start gap-3">
        <Shield className="w-6 h-6 text-yellow-600 flex-shrink-0 mt-0.5" />
        <div>
          <p className="font-medium text-yellow-800">Acceso total garantizado</p>
          <p className="text-sm text-yellow-700 mt-1">
            El rol Administrador siempre tiene acceso a todos los módulos del sistema, independientemente de los permisos configurados aquí. No es necesario modificarlo.
          </p>
        </div>
      </div>
    ) : (
      <>
        <div>
          <h3 className="text-md font-medium text-gray-700 mb-4">Permisos Disponibles</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {allModules.map((permiso) => (
              <label key={permiso} className="inline-flex items-center p-2 border rounded-md hover:bg-gray-50">
                <input
                  type="checkbox"
                  value={permiso}
                  checked={selectedModules.includes(permiso)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedModules([...selectedModules, permiso]);
                    } else {
                      setSelectedModules(selectedModules.filter(p => p !== permiso));
                    }
                  }}
                  className="form-checkbox h-5 w-5 text-yellow-600"
                />
                <span className="ml-2 text-gray-700">{permiso}</span>
              </label>
            ))}
          </div>
        </div>

        <div className="mt-6 flex justify-end">
          <button
            type="button"
            onClick={async () => {
              if (!selectedRole) {
                alert("Selecciona un rol primero");
                return;
              }
              try {
                setLoading(true);
                setLoadingMessage("Actualizando permisos... ⏳");
                const token = localStorage.getItem("access_token");
                await axios.patch(
                  `${process.env.REACT_APP_BACKEND_URL}/api/users/roles/${selectedRole.id}/update_modules/`,
                  { modules: selectedModules },
                  { headers: { Authorization: `Bearer ${token}` } }
                );
                await fetchRoles();
              } catch (err) {
                console.error(err);
                alert("Error al actualizar permisos ❌");
              } finally {
                setLoading(false);
                setLoadingMessage("");
              }
            }}
            className="bg-[#FF743A] text-white py-2 px-4 rounded-md"
          >
            Guardar Permisos
          </button>
        </div>
      </>
    )}
  </div>
)}
      {/* Pestaña Gestión de Usuarios */}
      {selectedTab === 3 && (
        <div>
          <div className="mt-6 flex justify-end">
          <button
            type="button"
            onClick={() => {
              setSelectedUser(null); // 👈 sin usuario seleccionado
              setEditFormData({
                username: "",
                first_name: "",
                last_name: "",
                email: "",
                telefono: "",
                password: "",
                groups: []
              });
              setIsCreatingUser(true);
              setModalError(null);
              setOpenModal(true);
            }}
            className="bg-[#FF743A] text-white py-2 px-4 rounded-md"
          >
            Agregar Usuario
          </button>
          </div>
          <GridComponent
            dataSource={users}
            allowPaging
            pageSettings={{ pageCount: 5 }}
            selectionSettings={{ persistSelection: true, type: "Single" }}
            toolbar={["Search"]}
            allowSorting
            rowSelected={handleRowSelected}
            className="mt-4"
          >
            <ColumnsDirective>
              {usersGrid.map((item, index) => (
                <ColumnDirective key={index} {...item} />
              ))}
            </ColumnsDirective>
            <Inject services={[Page, Selection, Toolbar, Sort, Filter]} />
          </GridComponent>
        </div>
      )}
      {/* Pestaña Catálogo web (solo Administrador) */}
      {selectedTab === 4 && esAdmin && <CatalogoWeb />}
      </div>{/* fin scrollable */}
      </div>
    </div>
  );
};

export default Seguridad;
